import React, { useState, useRef, useEffect } from "react";
import "./NewArrivalProduct.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const TrendingProduct = () => {
  const [activeTab, setActiveTab] = useState("necklaces");

  const products = [
    { primaryImg: "assets/images/product/medium-size/1-1.jpg", secondaryImg: "assets/images/product/medium-size/1-2.jpg", sticker: "New", name: "Pendant, Made of White Pl...", price: "£120.80", rating: 4 },
    { primaryImg: "assets/images/product/medium-size/1-3.jpg", secondaryImg: "assets/images/product/medium-size/1-4.jpg", sticker: "New", name: "Swirl 1 Medium Pendant La...", price: "£120.80", rating: 3 },
    { primaryImg: "assets/images/product/medium-size/1-5.jpg", secondaryImg: "assets/images/product/medium-size/1-6.jpg", sticker: "Sale", name: "Work Lamp Silver Proin he...", price: "£135.20", rating: 2 },
    { primaryImg: "assets/images/product/medium-size/1-7.jpg", secondaryImg: "assets/images/product/medium-size/1-8.jpg", sticker: "New", name: "Work Lamp Silver Proin he...", price: "£135.20", rating: 5 },
    { primaryImg: "assets/images/product/medium-size/1-9.jpg", secondaryImg: "assets/images/product/medium-size/1-1.jpg", sticker: "Sale", name: "Vitra Sunburst Clock pret...", price: "£1199.60", rating: 4 },
  ];

  const capitalize = (text) => text.charAt(0).toUpperCase() + text.slice(1);

  // Refs for custom arrows
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <div className="hiraola-product-tab_area-4">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">

            {/* Title & Tabs */}
            <div className="product-tab">
              <div className="hiraola-tab_title"><h4>Trending Products</h4></div>
              <ul className="nav product-menu">
                {["necklaces", "earrings", "bracelet", "anklet"].map((tab) => (
                  <li key={tab}>
                    <button className={activeTab === tab ? "active" : ""} onClick={() => setActiveTab(tab)}>
                      {capitalize(tab)}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Slider */}
            <div className="tab-content hiraola-tab_content" style={{ position: "relative" }}>
              <Swiper
                modules={[Navigation]}
                loop={products.length > 4} // loop only if more than visible slides
                spaceBetween={20}
                slidesPerView={4} // default for large screen
                navigation={{
                  prevEl: prevRef.current,
                  nextEl: nextRef.current,
                }}
                onBeforeInit={(swiper) => {
                  swiper.params.navigation.prevEl = prevRef.current;
                  swiper.params.navigation.nextEl = nextRef.current;
                }}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  480: { slidesPerView: 2 },
                  768: { slidesPerView: 3 },
                  1024: { slidesPerView: 4 },
                //   1200: { slidesPerView: 5 },
                }}
              >
              {products.map((product, index) => (
                    <SwiperSlide key={index}>
                      <div className="slide-item">
                        <div className="single_product">
                          <div className="product-img">
                            <a href="single-product.html">
                              <img
                                className="primary-img"
                                src={product.primaryImg}
                                alt="Product"
                              />
                              <img
                                className="secondary-img"
                                src={product.secondaryImg}
                                alt="Product"
                              />
                            </a>

                            <span
                              className={`sticker${
                                product.sticker === "Sale" ? "-2" : ""
                              }`}
                            >
                              {product.sticker}
                            </span>

                            <div className="add-actions">
                              <ul className="d-flex">
                                <li>
                                  <a
                                    className="hiraola-add_cart"
                                    href="cart.html"
                                    title="Add To Cart"
                                  >
                                    <i className="ion-bag"></i>
                                  </a>
                                </li>
                                <li>
                                  <a
                                    className="hiraola-add_compare"
                                    href="compare.html"
                                    title="Compare This Product"
                                  >
                                    <i className="ion-ios-shuffle-strong"></i>
                                  </a>
                                </li>
                                <li
                                  className="quick-view-btn"
                                  data-bs-toggle="modal"
                                  data-bs-target="#exampleModalCenter"
                                >
                                  <a href="#!" title="Quick View">
                                    <i className="ion-eye"></i>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>

                          <div className="hiraola-product_content">
                            <div className="product-desc_info">
                              <h6>
                                <a className="product-name" href="single-product.html">
                                  {product.name}
                                </a>
                              </h6>

                              <div className="price-box">
                                <span className="new-price">{product.price}</span>
                                  
                               
                                    {/* <a
                                      className="hiraola-add_compare"
                                      href="wishlist.html"
                                      title="Add To Wishlist" style={{ float: "right" }}
                                    >
                                      <i className="ion-android-favorite-outline"></i>
                                    </a> */}
                                 
                             
                              </div>

                            <div className="additional-add_action">
                                <ul>
                                    <li><a className="hiraola-add_compare"  style={{ float: "right" }} href="wishlist.html" data-bs-toggle="tooltip" data-placement="top" title="Add To Wishlist"><i
                                        className="ion-android-favorite-outline"></i></a>
                                    </li>
                                </ul>
                            </div>

                              <div className="rating-box">
                                <ul>
                                  {[...Array(5)].map((_, i) => (
                                    <li key={i}>
                                      <i
                                        className={`fa fa-star-of-david ${
                                          i < product.rating ? "active" : ""
                                        }`}
                                      ></i>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                 <button ref={prevRef} className="custom-prev slick-arrow" style={{ position: "absolute", top: "50%", left: "-25px", zIndex: 10, transform: "translateY(-50%)" }}>
                <i className="ion-ios-arrow-back"></i>
              </button>
              <button ref={nextRef} className="custom-next slick-arrow" style={{ position: "absolute", top: "50%", right: "-25px", zIndex: 10, transform: "translateY(-50%)" }}>
                <i className="ion-ios-arrow-forward"></i>
              </button>
              </Swiper>

              {/* Custom Arrows */}
             
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default TrendingProduct;

// import React, { useState, useRef, useEffect } from "react";
// import "./NewArrivalProduct.css";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";

// const TrendingProduct = () => {
//   const [activeTab, setActiveTab] = useState("necklaces");

//   const products = [
//     {
//       primaryImg: "assets/images/product/medium-size/1-1.jpg",
//       secondaryImg: "assets/images/product/medium-size/1-2.jpg",
//       sticker: "New",
//       name: "Pendant, Made of White Pl...",
//       price: "£120.80",
//       rating: 4,
//     },
//     {
//       primaryImg: "assets/images/product/medium-size/1-3.jpg",
//       secondaryImg: "assets/images/product/medium-size/1-4.jpg",
//       sticker: "New",
//       name: "Swirl 1 Medium Pendant La...",
//       price: "£120.80",
//       rating: 3,
//     },
//     {
//       primaryImg: "assets/images/product/medium-size/1-5.jpg",
//       secondaryImg: "assets/images/product/medium-size/1-6.jpg",
//       sticker: "Sale",
//       name: "Work Lamp Silver Proin he...",
//       price: "£135.20",
//       rating: 2,
//     },
//     {
//       primaryImg: "assets/images/product/medium-size/1-7.jpg",
//       secondaryImg: "assets/images/product/medium-size/1-8.jpg",
//       sticker: "New",
//       name: "Work Lamp Silver Proin he...",
//       price: "£135.20",
//       rating: 5,
//     },
//     {
//       primaryImg: "assets/images/product/medium-size/1-9.jpg",
//       secondaryImg: "assets/images/product/medium-size/1-1.jpg",
//       sticker: "Sale",
//       name: "Vitra Sunburst Clock pret...",
//       price: "£1199.60",
//       rating: 4,
//     },
//   ];

//   const capitalize = (text) =>
//     text.charAt(0).toUpperCase() + text.slice(1);

//   // Refs for custom navigation buttons
//   const prevRef = useRef(null);
//   const nextRef = useRef(null);

//   // Workaround for Swiper to recognize refs after rendering
//   const [swiperReady, setSwiperReady] = useState(false);
//   useEffect(() => {
//     setSwiperReady(true);
//   }, []);

//   return (
//     <div className="hiraola-product-tab_area-4">
//       <div className="container">
//         <div className="row">
//           <div className="col-lg-12">

//             {/* Title & Tabs */}
//             <div className="product-tab">
//               <div className="hiraola-tab_title">
//                 <h4>Trending Products</h4>
//               </div>

//               <ul className="nav product-menu">
//                 {["necklaces", "earrings", "bracelet", "anklet"].map((tab) => (
//                   <li key={tab}>
//                     <button
//                       className={activeTab === tab ? "active" : ""}
//                       onClick={() => setActiveTab(tab)}
//                     >
//                       {capitalize(tab)}
//                     </button>
//                   </li>
//                 ))}
//               </ul>
//             </div>

//             {/* Products Slider */}
//             <div className="tab-content hiraola-tab_content">
//               {swiperReady && (
//                 <Swiper
//                   modules={[Navigation]}
//                   loop
//                   spaceBetween={20}
//                   breakpoints={{
//                     1200: { slidesPerView: 4 },
//                     1024: { slidesPerView: 3 },
//                     768: { slidesPerView: 2 },
//                     480: { slidesPerView: 1 },
//                   }}
//                   navigation={{
//                     prevEl: prevRef.current,
//                     nextEl: nextRef.current,
//                   }}
//                   onBeforeInit={(swiper) => {
//                     swiper.params.navigation.prevEl = prevRef.current;
//                     swiper.params.navigation.nextEl = nextRef.current;
//                   }}
//                   className="hiraola-product_slider"
//                 >
//                   {products.map((product, index) => (
//                     <SwiperSlide key={index}>
//                       <div className="slide-item">
//                         <div className="single_product">
//                           <div className="product-img">
//                             <a href="single-product.html">
//                               <img
//                                 className="primary-img"
//                                 src={product.primaryImg}
//                                 alt="Product"
//                               />
//                               <img
//                                 className="secondary-img"
//                                 src={product.secondaryImg}
//                                 alt="Product"
//                               />
//                             </a>

//                             <span
//                               className={`sticker${
//                                 product.sticker === "Sale" ? "-2" : ""
//                               }`}
//                             >
//                               {product.sticker}
//                             </span>

//                             <div className="add-actions">
//                               <ul className="d-flex" style={{ marginTop: "110px" }}>
//                                 <li>
//                                   <a
//                                     className="hiraola-add_cart"
//                                     href="cart.html"
//                                     title="Add To Cart"
//                                   >
//                                     <i className="ion-bag"></i>
//                                   </a>
//                                 </li>
//                                 <li>
//                                   <a
//                                     className="hiraola-add_compare"
//                                     href="compare.html"
//                                     title="Compare This Product"
//                                   >
//                                     <i className="ion-ios-shuffle-strong"></i>
//                                   </a>
//                                 </li>
//                                 <li
//                                   className="quick-view-btn"
//                                   data-bs-toggle="modal"
//                                   data-bs-target="#exampleModalCenter"
//                                 >
//                                   <a href="#!" title="Quick View">
//                                     <i className="ion-eye"></i>
//                                   </a>
//                                 </li>
//                               </ul>
//                             </div>
//                           </div>

//                           <div className="hiraola-product_content">
//                             <div className="product-desc_info">
//                               <h6>
//                                 <a className="product-name" href="single-product.html">
//                                   {product.name}
//                                 </a>
//                               </h6>

//                               <div className="price-box">
//                                 <span className="new-price">{product.price}</span>
//                               </div>

//                               <div className="additional-add_action">
//                                 <ul>
//                                   <li>
//                                     <a
//                                       className="hiraola-add_compare"
//                                       href="wishlist.html"
//                                       title="Add To Wishlist"
//                                     >
//                                       <i className="ion-android-favorite-outline"></i>
//                                     </a>
//                                   </li>
//                                 </ul>
//                               </div>

//                               <div className="rating-box">
//                                 <ul>
//                                   {[...Array(5)].map((_, i) => (
//                                     <li key={i}>
//                                       <i
//                                         className={`fa fa-star-of-david ${
//                                           i < product.rating ? "active" : ""
//                                         }`}
//                                       ></i>
//                                     </li>
//                                   ))}
//                                 </ul>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </SwiperSlide>
//                   ))}
//                 </Swiper>
//               )}

//               {/* Custom Navigation Buttons */}
//               <div className="swiper-navigation">
//                 <button ref={prevRef} className="custom-prev slick-arrow">
//                   <i className="ion-ios-arrow-back"></i>
//                 </button>
//                 <button ref={nextRef} className="custom-next slick-arrow">
//                   <i className="ion-ios-arrow-forward"></i>
//                 </button>
//               </div>
//             </div>

//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TrendingProduct;
